// extracted by mini-css-extract-plugin
export var body = "telerik-layout-module--body--48558";
export var fullscreen = "telerik-layout-module--fullscreen--30606";
export var kendoApiBreadcrumb = "telerik-layout-module--kendoApiBreadcrumb--15d33";
export var landingPage = "telerik-layout-module--landingPage--1e6b1";
export var main = "telerik-layout-module--main--b29ab";
export var nav = "telerik-layout-module--nav--2028d";
export var rightNav = "telerik-layout-module--rightNav--ad626";
export var toc = "telerik-layout-module--toc--07d9a";
export var tocHidden = "telerik-layout-module--tocHidden--b73ba";